// src/core/platform/index.ts
// 플랫폼 브릿지 팩토리 — 런타임 감지 후 싱글톤 인스턴스 반환

import { detectPlatform, type PlatformBridge, type PlatformType } from "./platformBridge"
import { ElectronBridge } from "./electronBridge"
import { CapacitorBridge } from "./capacitorBridge"
import { WebBridge } from "./webBridge"

let bridge: PlatformBridge | null = null

/** 현재 플랫폼에 맞는 브릿지 싱글톤 반환 */
export function getPlatformBridge(): PlatformBridge {
  if (!bridge) {
    const platform = detectPlatform()
    switch (platform) {
      case "electron":
        bridge = new ElectronBridge()
        break
      case "capacitor":
        bridge = new CapacitorBridge()
        break
      default:
        bridge = new WebBridge()
    }
  }
  return bridge
}

/** 현재 플랫폼 타입 반환 */
export function getCurrentPlatform(): PlatformType {
  return getPlatformBridge().platform
}

/** 웹 빌드 여부 반환 */
export function isWebPlatform(): boolean {
  return __PLATFORM__ === "web"
}

// ── re-exports ──
export { detectPlatform }
export type { PlatformBridge, PlatformFeature, PlatformType, SaveDialogOptions, SaveDialogResult } from "./platformBridge"

